import { css, keyframes } from "@emotion/css";
import { mergeProps } from "react-aria";
import { Tooltip as AriaTooltip, TooltipProps } from "react-aria-components";

interface Props extends TooltipProps {
  testID: string;
}

export function _Tooltip(props: Props) {
  const { testID, ...tooltipProps } = props;

  return (
    <AriaTooltip
      {...mergeProps(tooltipProps, { className: styles.tooltip })}
      data-testid={testID}
    >
      {props.children}
    </AriaTooltip>
  );
}

const slide = keyframes`
  from {
    transform: var(--origin);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const styles = {
  tooltip: css({
    borderRadius: "var(--border-radius-2)",
    backgroundColor: "var(--background-accent-neutral-strong)",
    color: "var(--text-inverse)",
    forcedColorAdjust: "none",
    outline: "none",
    paddingTop: "var(--space-05)",
    paddingRight: "var(--space-2)",
    paddingBottom: "var(--space-05)",
    paddingLeft: "var(--space-2)",
    "--border-color": "var(--border-base)",
    boxShadow: "var(--shadow-menu)",
    maxWidth: "150px",
    /* fixes FF gap */
    transform: "translate3d(0, 0, 0)",

    "& *": {
      overflowWrap: "break-word",
    },

    "&[data-placement=top]": {
      marginBottom: "var(--space-05)",
      "--origin": "translateY(4px)",
    },

    "&[data-placement=bottom]": {
      marginTop: "var(--space-05)",
      "--origin": "translateY(-4px)",
    },

    "&[data-placement=right]": {
      marginLeft: "var(--space-05)",
      "--origin": "translateX(-4px)",
    },

    "&[data-placement=left]": {
      marginRight: "var(--space-05)",
      "--origin": "translateX(4px)",
    },

    "&[data-entering]": {
      animation: `${slide} 400ms`,
    },

    "&[data-exiting]": {
      animation: `${slide} 400ms reverse ease-in`,
    },
  }),
};
